import { useLocation } from "react-router-dom";

const CustomRejectedMessage__solicitud_postergacion_estudios_2023 = () => (
  <h4 className="text-center">
    Recuerda que el plazo para realizar este trámite es hasta el 29 de septiembre.
  </h4>
);

const SurveyRejectedScreen = () => {
  const location = useLocation();
  const { originSurveyRoute } = location.state ?? "";

  return (
    <>
      <h3 className="text-center">
        Está bien, puedes contestar el formulario en cualquier otro momento si así lo deseas. :)
      </h3>
      {originSurveyRoute === "solicitud-postergacion-estudios-2023" && (
        <CustomRejectedMessage__solicitud_postergacion_estudios_2023 />
      )}
    </>
  );
};

export default SurveyRejectedScreen;
